
export const JobCollabConstants: {[key: string]: string} = {
    account: 'Account',
    accountChooserHeader: 'Choose an Account',
    accountChooserCancel: 'Cancel',
    accountChooserContinue: 'Continue',
    addComments: 'Add comments...',
    analytics: 'Analytics',
    anniversaryBlurb: 'You have {0} employee',
    anniversaryBlurbPlural: 'anniversaries coming up:',
    anniversaryBlurbSingular: 'anniversary coming up:',
    anniversaryToday: 'Today',
    anniversaryTomorrow: 'Tomorrow',
    anniversaryYears: '- {0} years',
    approvalCompletionTitle: 'Great Work!',
    approvalCompletionsBody: 'Your feedback has been submitted for this job',
    approvalCompletionLink: 'Return to Jobs',
    certs: 'Certifications',
    education: 'Education',
    eeDetails: 'Employee Details',
    email: 'Email',
    employees: 'Employees',
    experience: 'Experience',
    forgotPassword: 'Forgot Password?',
    forgotPasswordHeader: 'Forgot your password?',
    forgotPasswordBody: 'Enter your email and we\'ll send you a link to reset your password.',
    hi: 'Hi {0},',
    hiNoName: 'Hi,',
    home: 'Home',
    jobApprovalHeader: 'Does this job look correct?',
    jobs: 'Jobs',
    jobDetailsBasePayHeader: 'Target at 50th',
    jobDetailsLocationHeader: 'Location',
    jobDetailsSummaryEmployee: 'Employees',
    jobDetailsSummaryGrade: 'Salary Grade',
    jobDetailsSummaryExperience: 'Years Exp',
    jobDetailsTopCompFactors: 'Top Compensable Factors',
    jobNeedsReview: 'Feedback requested',
    jobNeedsReviewAlertBody: 'Submit your feedback to your HR team ',
    jobNeedsReviewAlertHeader: 'This job requires your review and feedback',
    jobNeedsReviewBy: 'by {0}',
    jobResponsibilities: 'Job Responsibilities',
    jobsInReview: 'Job Feedback',
    jobsInReviewModalBody: 'Your feedback helps us get the details right for your jobs.',
    jobsInReviewModalTitle: 'New job feedback request',
    later: 'Later',
    letsCelebrate: 'Let\'s celebrate!',
    locationNotSet: 'Not Set',
    loggedOutText: 'You have been successfully logged out.',
    login: 'Login',
    loginFailed: 'Login failed, please try again.',
    logInLink: 'Log back in',
    logout: 'Logout',
    looksGreat: 'Looks Great',
    managmentResponsibilities: 'Management Responsibilities',
    manualJobReviewLink: 'Submit feedback for this job',
    manualJobReviewLinkCancel: 'Cancel feedback',
    marketData: 'Market Data',
    needsWork: 'Needs Work',
    noEmployeesHeader: 'No Employees Available',
    noEmployeesBody: 'Looks like you do not have any employees reporting to you.',
    noEmployeeDetails: 'No details for employee',
    noJobsInListHeader: 'No Jobs Available',
    noJobsInListBody: 'Looks like you do not have any jobs reporting to you.',
    noJobDetails: 'No details for job',
    noNameInitials: '',
    noPayRange: 'Pay range data unavailable',
    notFoundHeader: 'Whoops!',
    notFoundLink: 'Return home',
    notFoundText: 'Sorry, this page doesn\'t exist.',
    pageTitle: 'PayScale {0}',
    pageTitleEmployeeDetails: '{0} - Employee Details',
    pageTitleEmployees: '{0} - Employees',
    pageTitleHome: '{0} - Home',
    pageTitleJobDetails: '{0} - Job Details',
    pageTitleJobs: '{0} - Jobs',
    pageTitleLogin: '{0} - Login',
    password: 'Password',
    passwordEmailSentHeader: 'Check your email',
    passwordEmailSentBody: 'Your password reset link has been sent to your email',
    passwordEmailSentFooter: 'If you do not receive an email or continue to ' +
        'have trouble logging in, contact your HR team.',
    payscaleJobMatchTitle: 'PayScale Job Match',
    payscaleJobMatchJobReviewSubTitle: 'Matched to PayScale job title',
    payscaleJobMatchSubTitle: 'This job is matched to',
    payscaleJobMatchTaskTitle: 'Tasks for this job',
    perHour: '/hr',
    productName: 'Team',
    returnToLogin: 'Return to login',
    reviewNow: 'Review Now',
    select: '--Select--',
    selectableItemsMainHeader: 'Which {0} add value to this job?',
    selectableItemsCurrentHeader: 'Current {0}',
    selectableItemsSuggestedHeader: 'Select additional {0}',
    sendResetLink: 'Send Reset Link',
    sessionExpired: 'Session expired',
    sessionTimeoutText: 'You have been logged out due to inactivity',
    skills: 'Skills',
    skillsAndCerts: 'Skills and Certifications',
    searchSkillsCertsPlaceholder: 'Search for {0}',
    statusError: 'An error occurred',
    statusLoading: 'Loading...',
    statusLoggingIn: 'Logging in...',
    statusReload: 'Please reload the page and try again or',
    statusTimeout: 'Request timed out',
    submitBy: 'Submit by {0}.',
    submitReview: 'Submit Feedback',
    switchAccounts: 'Switch Accounts',
    teamOverviewLink: 'Overview',
    teamTeamsLink: 'Teams',
    teamSummary: 'Here\'s your team summary',
    twelveMonths: '12 months',
    unitMillions: 'm',
    unitThousands: 'k',
    unspecifiedValue: '--'
};
